class PdpStickyForm extends HTMLElement {
  constructor() {
    super();
    this.productMain = document.querySelector('.product__info-wrapper');
    this.targetButton = this.productMain.querySelector('.product .product__info-wrapper .product-form__buttons');
    this.media = window.matchMedia('(max-width: 768px)')

    this.querySelectorAll('.button-scroll-top').forEach((btn) => {
      btn.addEventListener('click', this.scrolltop.bind(this));
    });


     
    if(this.media.matches) {
      window.addEventListener('scroll', this.checkButtonVisibility.bind(this));
      window.addEventListener('resize', this.checkButtonVisibility.bind(this));
      this.checkButtonVisibility();
    } else {
      this.target_div = document.querySelector('.main-product-section'); 
      this.targetHeight = this.target_div.offsetHeight; 
      window.addEventListener('scroll', this.checkScrollPosition.bind(this));
    }
  }

  scrolltop() {
    const targetElement = this.targetButton;
    const targetPosition = targetElement.getBoundingClientRect().bottom + window.pageYOffset - window.innerHeight + 10;
    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    });
  }
  checkScrollPosition() {
    const screenWidth = window.innerWidth;
    if (screenWidth < 769) {
      const targetButtonRect = this.targetButton.getBoundingClientRect().bottom;
      if (targetButtonRect <= 0) {
        this.classList.add('show_sticky');
      } else {
        this.classList.remove('show_sticky');
      }
    }
    else{
      const scrollTop = window.scrollY;
      const targetTop = this.target_div.getBoundingClientRect().top + this.target_div.offsetHeight ;
      const scrollPosition = scrollTop - targetTop;
      if (scrollPosition > this.targetHeight) {
        this.classList.add('show_sticky');
      } else {
        this.classList.remove('show_sticky');
      }
    }
  }

  checkButtonVisibility() {
    const buttonRect = this.targetButton.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    const visibleHeight = Math.min(buttonRect.bottom, windowHeight) - Math.max(buttonRect.top, 0);
    const visibilityThreshold = buttonRect.height * 0.2;
    if (visibleHeight > visibilityThreshold) {
      this.classList.remove('show_sticky');
    } else {
      this.classList.add('show_sticky');
    }
  }

  changeVariant() {
    const selectedVariant = document.querySelector('.form-input--size input[type="radio"]:checked');
    if (selectedVariant) {
      const variantName = selectedVariant.value;
      this.querySelector('.sticky-form-variant').textContent = variantName;
    }
  }
}
customElements.define('product-sticky-form', PdpStickyForm);